/* 
* 星级 悬浮显示的内容
 */
<template>
  <div class="star-assistant-ranking-chart" 
    v-loading="!chartRankingData.isExit"
  >
    <div class="star-header">
      <span class="star-header_label">星级分布</span>
    </div>
    <div class="star-content">
      <div class="star-content-asin">
        <gj-image :size="50" :src="row.imageUrl" tag-color="rgb(246,144,10)">
        </gj-image>
        <div class="star-content-asin_label">
          <div class="star-inner">ASIN: {{ row.asin | defaultShow }}</div>
          <div class="star_val">
            <gj-rate disabled :value="row.star"></gj-rate>
            <span class="star_val-text">{{ row.star }}</span>
          </div>
        </div>
      </div>
      <div>
        <div class="star-basic_info">
          <div class="star-basic_info_val">{{commentBarData.ratingQuantityCount}}</div>
          <div class="star-basic_info_inner">总评星数</div>
        </div>
        <ve-ring 
        height="300px"
        :data-empty="chartRankingData.empty"
        :data="chartRankingData.chartData" 
        :settings="chartRankingData.chartSettings" 
        :extend="chartRankingData.chartExtend" >
        </ve-ring>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  props: {
    commentBarData: {
      type: Object,
      default: _ => ({})
    },
    row: {
      type: Object,
      default: (_) => ({}),
    },
  },
  data() {
    return {
    };
  },
  computed: {
    chartRankingData() {
      let isExit = JSON.stringify(this.commentBarData) !== '{}'
      let res = this.commentBarData
      const resVal = {
        oneStarProportion: {
          val: res.oneStarProportion,
          text: '一星'
        },
        twoStarProportion: {
          val: res.twoStarProportion,
          text: '二星'
        },
        threeStarProportion: {
          val: res.threeStarProportion,
          text: '三星'
        },
        fourStarProportion: {
          val: res.fourStarProportion,
          text: '四星'
        },
        fiveStarProportion: {
          val: res.fiveStarProportion,
          text: '五星' 
        },
        ratingQuantityCount: 1245
      }
      let rows= []
      rows = Object.keys(resVal).map(v => ({
        ratio: resVal[v].val,
        distributionName: resVal[v].text,
      }))
      return {
        isExit,
        chartData: {
          columns: ["distributionName", "ratio"],
          rows
        },
        chartSettings: {
          radius: ['100px', '60px'],
          hoverAnimation: false,
          dataType: 'KMB',
          label: {
            show: false
        },
        empty: !rows.length,
      },
      
      chartExtend: {
        tooltip: {
          formatter(params) {
            return `
              <div>
                ${params.name} ${params.value}%
              </div>
            `
          }
        },
        legend: {
            orient: 'vertical',
            align: 'auto',
            right: '50px',
            itemGap: 30 ,
            top: 'center',
            formatter: (name,type) => {
              const val = rows.find(v => v.distributionName === name).ratio
              return `${name}         ${(val || val === 0) ? val + '%' : ''}`
            },
          },
          color: ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#f5dab1'],
          series: {
            center: ['40%', '40%'],
          }
        },
      }
    }
  },
  created() {
  },
  methods: {
    getInfo() {}
  }
};
</script>

<style lang="scss">
.star-assistant-ranking-chart {
  .star-header {
    display: flex;
    justify-content: space-between;
    padding: 10px 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #e5e5e5;
    .star-header_label {
      color: #333;
      font-weight: 600;
      font-size: 16px;
    }
  }
  .star-content {
    padding: 20px 25px;
    box-sizing: border-box;
    .star-content-asin {
      display: flex;
      align-items: center;
      .star-content-asin_label {
        margin-left: 10px;
        .star-inner {
          color: #333;
          font-size: 14px;
        }
        .star_val {
          margin-top: 10px;
          display: flex;
          .star_val-text {
            color: #333;
          }
        }
      }
    }
    .star-basic_info {
      position: absolute;
      top: 54%;
      transform: translateY(-50%);
      left: 37%;
      text-align: center;
      color: #333;
      .star-basic_info_val {
        font-weight: bold;
        font-size: 22px;
      }
      .star-basic_info_inner {
        margin-top: 5px;
        font-size: 14px;
      }
    }
  }
  
}
</style>